import HomePage from '../Home';
import { FAVORITE_LOTS_PAGE } from '../../constants';

const Favorites = () => <HomePage title={FAVORITE_LOTS_PAGE.title} />;

export default Favorites;
